import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pool/getCrearExcelBatchUSA`, method: 'POST', body: values, token: token})
}
